var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2432 7.92804L15.1076 2H13.9549L9.73118 7.14724L6.3577 2H2.4668L7.56815 9.78354L2.4668 16H3.61956L8.07992 10.5643L11.6426 16H15.5335L10.243 7.92804H10.2432ZM8.66437 9.85211L8.1475 9.07705L4.03492 2.90978H5.80549L9.12439 7.88696L9.64127 8.66202L13.9554 15.1316H12.1849L8.66437 9.85241V9.85211Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.3527fa503564fc50a88e48dde77d124f.svg";
export { ForwardRef as ReactComponent };